
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public/wpCms",
      function () {
        return require("private-next-pages/public/wpCms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public/wpCms"])
      });
    }
  